(() => {
  const initializeCustomShop = () => {
    const body = document.querySelector('.template-page-custom-shop');
    if (!body || body.dataset.customShopInitialized === 'true') return;
    body.dataset.customShopInitialized = 'true';

    const storyContent = body.querySelector('.ormsby-section-container');
    const story = storyContent?.closest('.shopify-section');
    const videoContent = body.querySelector('.video-section');
    const video = videoContent?.closest('.shopify-section');
    const galleries = [...body.querySelectorAll('.gallery-section')];
    const collectionContent = body.querySelector('.featured-collection')
      || body.querySelector('.collection');

    if (storyContent) storyContent.id = 'custom-shop-overview';
    if (videoContent) videoContent.id = 'custom-shop-film';
    if (galleries[0]) {
      const galleryContent = galleries[0].querySelector('.page-width');
      if (galleryContent) galleryContent.id = 'custom-shop-gallery';
      galleries[0].dataset.customFirstGallery = 'true';
    }
    if (collectionContent) collectionContent.id = 'custom-shop-available';

    body.querySelectorAll('.ormsby-section-container .enhanced-richtext br').forEach((lineBreak) => {
      lineBreak.replaceWith(document.createTextNode(' '));
    });

    if (story && !body.querySelector('.custom-shop-nav')) {
      const nav = document.createElement('nav');
      nav.className = 'custom-shop-nav';
      nav.setAttribute('aria-label', 'Custom Shop page navigation');
      nav.innerHTML = `
        <div class="custom-shop-nav__inner">
          <a href="#custom-shop-overview">The craft</a>
          <a href="#custom-shop-film">Workshop film</a>
          <a href="#custom-shop-gallery">Build archive</a>
          <a href="#custom-shop-available">Available guitars</a>
        </div>
      `;
      story.insertAdjacentElement('afterend', nav);
    }

    const galleryItems = galleries.flatMap((gallery) => [...gallery.querySelectorAll('.gallery-item')]);
    const initialCount = 24;
    const revealCount = 24;
    let visibleCount = Math.min(initialCount, galleryItems.length);

    body.querySelectorAll('.custom-shop-gallery-actions').forEach((actions) => actions.remove());

    galleryItems.forEach((item, index) => {
      item.classList.remove('custom-shop-gallery-hidden');
      item.removeAttribute('aria-hidden');

      const image = item.querySelector('.gallery-item__image');
      if (image && (!image.alt || image.alt === 'Gallery image')) {
        image.alt = `Ormsby Custom Shop guitar ${index + 1}`;
      }

      if (index >= visibleCount) {
        item.classList.add('custom-shop-gallery-hidden');
        item.setAttribute('aria-hidden', 'true');
      }
    });

    if (galleryItems.length > visibleCount && galleries.length) {
      const actions = document.createElement('div');
      actions.className = 'custom-shop-gallery-actions';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'custom-shop-gallery-more';
      button.setAttribute('aria-controls', 'custom-shop-gallery');

      const updateButton = () => {
        const remaining = galleryItems.length - visibleCount;
        button.textContent = remaining > 0
          ? `Show more builds (${remaining})`
          : 'All builds shown';
        button.disabled = remaining === 0;
        if (remaining === 0) actions.remove();
      };

      button.addEventListener('click', () => {
        const nextCount = Math.min(visibleCount + revealCount, galleryItems.length);
        galleryItems.slice(visibleCount, nextCount).forEach((item) => {
          item.classList.remove('custom-shop-gallery-hidden');
          item.removeAttribute('aria-hidden');
        });
        visibleCount = nextCount;
        updateButton();
      });

      updateButton();
      actions.append(button);
      galleries[galleries.length - 1].insertAdjacentElement('afterend', actions);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCustomShop);
  } else {
    initializeCustomShop();
  }

  document.addEventListener('shopify:section:load', () => {
    const body = document.querySelector('.template-page-custom-shop');
    if (body) delete body.dataset.customShopInitialized;
    initializeCustomShop();
  });
})();
